import { EllipsedText, Loading, VirtualizedComponent } from '@gorila-shared-ui/components';
import { ListItem, ListItemLabel } from 'baseui/list';
import { CSSProperties, memo, useRef } from 'react';
import { ListChildComponentProps } from 'react-window';
import { useRecoilState, useRecoilValue } from 'recoil';
import { useHover } from 'usehooks-ts';
import { SMALL_LIST_ITEM_HEIGHT } from '../../constants/app';
import { useStyles } from '../../hooks/useStyles';
import { groupState, selectedGroupIdState } from '../../storage/groups';

function GroupItem({ data, index, style }: Readonly<ListChildComponentProps<VirtualizedComponent['data']>>) {
  const { overrides } = useStyles();
  const [selectedGroupId, setSelectedGroupId] = useRecoilState(selectedGroupIdState);
  const groupId = data.items[index];
  const group = useRecoilValue(groupState(groupId));
  const hoverRef = useRef(null);
  const isHover = useHover(hoverRef);

  const isSelected = selectedGroupId === groupId;

  const onSelectGroup = () => {
    if (selectedGroupId === groupId) setSelectedGroupId(undefined);
    else setSelectedGroupId(groupId);
  };

  return (
    <span
      style={style as CSSProperties}
      ref={hoverRef}
    >
      {data.isLoaded(index) ? (
        <ListItem
          overrides={overrides.listItemOverrides({
            onClick: onSelectGroup,
            isHover,
            isSelected,
            minHeight: SMALL_LIST_ITEM_HEIGHT,
          })}
        >
          <ListItemLabel>
            <EllipsedText inline>{group?.name || '-'}</EllipsedText>
          </ListItemLabel>
        </ListItem>
      ) : (
        <Loading size="compact" />
      )}
    </span>
  );
}

export default memo(GroupItem);
